import React, { useEffect, useRef, useState } from 'react';
import './Cursor.css';

export default function CustomCursor() {
    const dotRef  = useRef(null);
    const ringRef = useRef(null);
    const mouse   = useRef({ x: 0, y: 0 });
    const ringPos = useRef({ x: 0, y: 0 });
    const rafId   = useRef(null);

    const [visible,  setVisible]  = useState(false);
    const [clicking, setClicking] = useState(false);
    const [hovering, setHovering] = useState(false);
    const [onDark,   setOnDark]   = useState(false);

    useEffect(() => {
        const dot  = dotRef.current;
        const ring = ringRef.current;

        const onMouseMove = (e) => {
        mouse.current = { x: e.clientX, y: e.clientY };
        if (!visible) setVisible(true);

        dot.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;

        const el = document.elementFromPoint(e.clientX, e.clientY);
        if (el) {
            const isDark =
                el.closest('.problem')            ||
                el.closest('.adopt-callout')      ||
                el.closest('.on-request')         ||
                el.closest('.robotics-teaser')    ||
                el.closest('.cta-strip')          ||
                el.closest('.robotics-problem')   ||
                el.closest('.robotics-waitlist')  ||
                el.closest('.robotics-hero')      ||
                el.closest('.work-cta');
            setOnDark(!!isDark);
        }
        };

        const INTERACTIVE = 'a, button, input, textarea, select, [role="button"], .service-card, .work-preview__hex, .problem__card';
        const onMouseOver  = (e) => { if (e.target.closest(INTERACTIVE)) setHovering(true); };
        const onMouseOut   = (e) => { if (e.target.closest(INTERACTIVE)) setHovering(false); };
        const onMouseDown  = () => setClicking(true);
        const onMouseUp    = () => setClicking(false);
        const onMouseLeave = () => setVisible(false);
        const onMouseEnter = () => setVisible(true);

        document.addEventListener('mousemove',  onMouseMove);
        document.addEventListener('mouseover',  onMouseOver);
        document.addEventListener('mouseout',   onMouseOut);
        document.addEventListener('mousedown',  onMouseDown);
        document.addEventListener('mouseup',    onMouseUp);
        document.addEventListener('mouseleave', onMouseLeave);
        document.addEventListener('mouseenter', onMouseEnter);

        const LERP = 0.12;
        const animate = () => {
        ringPos.current.x += (mouse.current.x - ringPos.current.x) * LERP;
        ringPos.current.y += (mouse.current.y - ringPos.current.y) * LERP;
        ring.style.transform = `translate(${ringPos.current.x}px, ${ringPos.current.y}px)`;
        rafId.current = requestAnimationFrame(animate);
        };
        rafId.current = requestAnimationFrame(animate);

        return () => {
        document.removeEventListener('mousemove',  onMouseMove);
        document.removeEventListener('mouseover',  onMouseOver);
        document.removeEventListener('mouseout',   onMouseOut);
        document.removeEventListener('mousedown',  onMouseDown);
        document.removeEventListener('mouseup',    onMouseUp);
        document.removeEventListener('mouseleave', onMouseLeave);
        document.removeEventListener('mouseenter', onMouseEnter);
        cancelAnimationFrame(rafId.current);
        };
    }, [visible]);

    const classes = (base) => [
        base,
        visible  ? 'cursor--visible'  : '',
        clicking ? 'cursor--clicking' : '',
        hovering ? 'cursor--hovering' : '',
        onDark   ? 'cursor--on-dark'  : '',
    ].join(' ');

    return (
        <>
            <div ref={dotRef}  className={classes('cursor-dot')}  aria-hidden="true" />
            <div ref={ringRef} className={classes('cursor-ring')} aria-hidden="true" />
        </>
    );
}